// import React, { useEffect, useState } from "react";

// export default function Offer() {
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     document.title = "Ads";

//     fetch("https://lifetimedesign.in/LtcJsonAPI.asmx/DesignList?icid=350")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           setOffers(data.data);
//         }
//       })
//       .catch((err) => console.error(err))
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) {
//     return (
//       <div style={styles.loadingContainer}>
//         <div className="spinner-border text-primary mb-3"></div>
//         <h5>Please wait...</h5>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.page}>
//       <div className="container1">
//         <nav aria-label="breadcrumb">
//           <ol className="breadcrumb">
//             <li className="breadcrumb-item">
//               <a href="/">
//                 <i className="bi bi-house"></i> Home
//               </a>
//             </li>
//             <li className="breadcrumb-item active">Ads</li>
//           </ol>
//         </nav>

//         <div className="row">
//           {offers.map((offer) => (
//             <div className="col-md-4 mb-4" key={offer.id}>
//               <img
//                 src={`https://lifetimedesign.in/controlpanel/Designs/${offer.image_url}`}
//                 alt={offer.code}
//                 className="img-fluid12"
//                 style={{
//                   borderRadius: "8px",
//                   display: "block",
//                 }}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   page: {
//     minHeight: "100vh",
//     background: "linear-gradient(135deg, #f6f8fc, #eef2f7)",
//     padding: "20px 15px",
//   },
//   loadingContainer: {
//     minHeight: "100vh",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//   },
// };
import React, { useEffect, useState } from "react";

export default function Ads() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Offers";

    fetch("https://lifetimedesign.in/LtcJsonAPI.asmx/DesignList?icid=350")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setOffers(data.data);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div className="spinner-border text-primary mb-3"></div>
        <h5>Please wait...</h5>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div className="container-fluid">
        {/* Breadcrumb */}
        <div className="mb-3">
          🏠 Home <span style={{ margin: "0 8px" }}>›</span>
          <span style={{ color: "red" }}>Offers</span>
        </div>

        <div className="offers-grid">
          {offers.map((offer) => (
            <div className="offer-card" key={offer.id}>
              <div className="offer-image-box">
                <img
                  src={`https://lifetimedesign.in/controlpanel/Designs/${offer.image_url}`}
                  alt={offer.code}
                  className="offer-image"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f6f8fc, #eef2f7)",
    padding: "20px 15px",
  },
  loadingContainer: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};
